import { Stack, Typography } from "@mui/material";
import { useConfirmation } from "../../contexts/confirmation-context/ConfirmationContext";
import { useTranslation } from "react-i18next";
import useManualEntryFormState from "./ManualEntryFormViewState";
import FullScreenDialog, { FullScreenDialogCloseReason } from "../../components/full-screen-dialog/FullScreenDialog";
import SettingsBar, { SettingsActionEnum } from "../../components/settings-bar/SettingsBar";
import { bindDialog, BindDialogReturn, DialogProps, DialogResult, DialogState, useDialogState } from "../../hooks/use-dialog-state/UseDialogState";
import { IeLynxObject } from "../../common/models/eLynxObject";
import ManualEntryFormContent from "./ManualEntryFormContent";
import { useEffect } from "react";
import { format } from "date-fns";

export type ManualEntryFormDialogInitValues = {
    elynxObject: IeLynxObject;
    date: Date;

};

export type ManualEntryFormDialogResultValues = {

};

export type ManualEntryFormDialogResultReason = FullScreenDialogCloseReason | "cancel" | "save";

export type ManualEntryFormDialogResult = DialogResult<ManualEntryFormDialogResultValues, ManualEntryFormDialogResultReason>;

export type ManualEntryDialogProps = DialogProps<ManualEntryFormDialogInitValues, ManualEntryFormDialogResult>;

export default function ManualEntryFormView({ 
    open,
    onClose,
    values
 
}: ManualEntryDialogProps) {

    const { confirm } = useConfirmation();
    const {t} = useTranslation();
    const manualEntryFormState = useManualEntryFormState();
     const { 
        state,
    } = manualEntryFormState;

    async function getUserConfirmation() {

        const response = await confirm({
            dialogTitle: t('cancelConfirmation.title'),
            confirmationText: t('tag.cancelEditText'),
            yesButtonText: t('cancelConfirmation.yesButtonText'),
            noButtonText: t('cancelConfirmation.noButtonText'),
            showConfirmationText: true,
            showYesButton: true,
            showNoButton: true
        });
        
        return response === "yes";
    };



    async function onCancel() {

        const canCancel = state.formState.isDirty
            ? await getUserConfirmation()
            : true;

        if (canCancel) {


            onClose && onClose({ 
                reason: "cancel" 
            });
        }
    }

    useEffect(() => {

        if (values?.date) {
            const date = new Date(values.date);
            date.setHours(0, 0, 0, 0);

            if (date.valueOf() !== state.selectedDate.valueOf()) {
                manualEntryFormState.setSelectedDate(date);
            }
        }
    }, [
        values?.date,
        state.selectedDate,
        manualEntryFormState
    ]);

    return (
        <FullScreenDialog open={open} onClose={reason => onClose({ reason: reason })}>
            <SettingsBar title={
                <Stack
                    direction='column'
                    sx={{
                        marginTop: 1,
                        marginBottom: 1
                    }}>
                    {/* <Typography variant='h6'>
                        {t('views.manualEntry')}
                    </Typography> */}
                    <Typography variant='h6'>
                        {values?.date ? format(values.date, 'LLLL dd, yyyy') : ''}
                    </Typography>

                    <Typography variant='h6'>
                        {values?.elynxObject?.displayText}
                    </Typography>
                </Stack>

            } 
                onClose={
                    async (reason: SettingsActionEnum) => {
                        if (reason === SettingsActionEnum.Close) {
                            onCancel();
                        }
                    }}
                
                hideAction={true}
            />
            {
                values?.elynxObject &&
                <ManualEntryFormContent elynxObject={values?.elynxObject} manualEntryFormState={manualEntryFormState} />
            }
        </FullScreenDialog>
    );

}



export type ManualEntryFormDialogState = DialogState<ManualEntryFormDialogInitValues, ManualEntryFormDialogResult>;
export type BindManualEntryFormDialogReturn = BindDialogReturn<ManualEntryFormDialogInitValues, ManualEntryFormDialogResult>;

export function useManualEntryFormDialogState(): ManualEntryFormDialogState {
    return useDialogState();
}

export function bindManualEntryFormDialog(props: ManualEntryFormDialogState): BindManualEntryFormDialogReturn {
    return bindDialog(props);
}

